import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Typography, Spin, Alert, Table } from 'antd';
import apiClient from '../../../apis/ApiInterceptor';

const { Title } = Typography;

const PastPlans = ({ userId, className, refreshKey}) => {
    const [pastPlans, setPastPlans] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!userId) {
            setError("No se proporcionó un ID de usuario.");
            setLoading(false);
            return;
        }

        const fetchPastPlans = async () => {
            try {
                setLoading(true);
                const params = {};
                params.limit = 10;
                params.expired = true;
                const response = await apiClient.get(`/users/${userId}/plans`, { params: params , }); // TODO: move this to api
                setPastPlans(response.data);
                setLoading(false);
            } catch (err) {
                setError("Error al cargar el plan del usuario.");
                setLoading(false);
            }
        };

        fetchPastPlans();
    }, [userId, refreshKey]);

    if (loading) {
        return (
            <div className={`${className} text-center`}>
                <Spin size="large" />
            </div>
        );
    }

    if (error) {
        return (
            <div className={`${className} text-center`}>
                <Alert message="Error" description={error} type="error" showIcon />
            </div>
        );
    }

    if (!pastPlans || pastPlans.length === 0) {
        return (<></>);
    }

    const columns = [
        {
            title: 'Plan',
            dataIndex: 'name',
            key: 'name',
            align: 'center',
        },
        {
            title: 'F. Activación',
            dataIndex: 'activation_date',
            key: 'activation_date',
            align: 'center',
            render: (date) => moment.utc(date).local().format('DD/MM/YYYY'),
        },
        {
            title: 'F. Expiración',
            dataIndex: 'expiration_date',
            key: 'expiration_date',
            align: 'center',
            render: (date) => moment.utc(date).local().format('DD/MM/YYYY'),
        },
        {
            title: 'Clases Restantes',
            dataIndex: 'remaining_shared_classes',
            key: 'remaining_shared_classes',
            align: 'center',
        },
      ];

    return (
        <div className={`${className} w-100`}>
            <Title level={3} className="text-center">Planes Vencidos</Title>
            <div className="themed-block text-center col-12 col-md-10 py-3 mx-auto mb-3 table-responsive">
                <Table
                    dataSource={pastPlans.map((item, index) => ({ ...item, key: index }))}
                    columns={columns}
                    className="text-center"
                    pagination={false}
                    scroll={{ x: '100%' }}
                />
            </div>
        </div>
    );
};

export default PastPlans;
